import {
  actions,
  apiLogSplunkEvent,
  SPLUNK_EVENT_STATUS, STATUS_CODES, UI_FLOWS,
} from '@americanexpress/amex-connect-core';
import { fromJS } from 'immutable';

export const fetchUserLookup = ({
  connectApiUrl, redirectToLogin, splunkLogQueue, dispatch,
}) => {
  const logData = {
    eventStatus: SPLUNK_EVENT_STATUS.SUCCESS,
    eventName: 'MYCA_LOGIN_EVENT',
  };
  splunkLogQueue.push(logData);

  const headers = {
    Accept: 'application/json',
    'selected-partner': 'BPAY',
    'Content-Type': 'application/json',
    Source: 'PARTNER_WEB',
  };

  fetch(`${connectApiUrl}/userlookup`, {
    headers,
    method: 'get',
    credentials: 'include',
  }).then((resp) => {
    if (!resp.ok) {
      if (resp.status === 401) {
        redirectToLogin();
      }
      throw new Error(resp.status);
    }
    return resp.json();
  }).then((data) => {
    const { redirect_url: redirectUrl, access_token: accessToken } = data;
    if (redirectUrl && accessToken) {
      dispatch({ type: 'modules/amex-connect-root/UPDATE_SPLUNK_TOKEN', payload: accessToken });
      // updateAccessToken(accessToken);
      // send the logs then redirect
      /* istanbul ignore next */
      setTimeout(() => {
        splunkLogQueue.forEach((log, idx) => {
          // logSplunkEvent(log);
          dispatch(apiLogSplunkEvent(logData));
          if (splunkLogQueue.length - 1 === idx) {
            window.location.href = redirectUrl;
          }
        });
      }, 100);
    }
  }).catch(() => {
    dispatch(actions.mergeValues(fromJS({
      partner: 'BPAY',
      isAccountsLoaded: true,
      currentFlow: UI_FLOWS.ERROR,
      error: STATUS_CODES.SYSTEM,
    })));
  });
};
